import * as React from "react";
import "./modal.scss";

export interface IModalProps {
    onClose: () => void,
    show: boolean,
    className?: string,
    passthrough?: boolean
}

export interface IModalState {
}

export class Modal extends React.Component<IModalProps, IModalState> {

    constructor(props: IModalProps) {
        super(props);

        this.props = props;

        this.state = {
        };
    }

    componentDidMount() {
        if (this.props.show) {
            document.body.classList.add("ncb-modal-open");
        }
    }

    componentWillUnmount() {
        document.body.classList.remove("ncb-modal-open");
    }

    componentWillReceiveProps(nextProps: IModalProps) {
        if (nextProps.show!== this.props.show) {
            if (nextProps.show) {
                document.body.classList.add("ncb-modal-open");
            }
            else {
                document.body.classList.remove("ncb-modal-open");
            }
        }
    }

    render() {
        if (this.props.passthrough === true)
            return <div className="ncb-modal-passthrough">{this.props.children}</div>

        if (!this.props.show)
            return null;

        return <div className="ncb-modal-wrapper">
            <div className={"ncb-modal-content " + (this.props.className == null ? "" : this.props.className)}>
                <span className="ncb-modal-close" onClick={(e: any) => { e.stopPropagation(); this.props.onClose();}}></span>
                <div className="ncb-modal-inner">
                    {this.props.children}
                </div>
            </div>
        </div>;
    }
}



// WEBPACK FOOTER //
// ./src/components/shared/modal.tsx